
export const getters = {

    systemShippinglines: state => state.shippinglines,
    Shippingline: state => state. systemShippingline
}
export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/shippinglines/getters.js